import Style from './ResetPasswordBrick.module.less';
import FJNav from '../common/FJNav/FJNav';
import FJLocalStore from '../../store/FJLocalStore';
import FJInput from '../common/FJInput/FJInput';
import FJButton from '../common/FJButton/FJButton';
import { useCallback, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import FJErrTip from '../common/FJErrTip/FJErrTip';
import useLocalStore from '../../hooks/useLocalStore';
import FJUtil from '../../util/FJUtil';

const ResetPasswordBrick = props => {
    useLocalStore();
    let { email, stepChange, resetClick, popupType, active } = props;
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [load, setLoad] = useState(false);
    const [errTip, setErrTip] = useState(null);
    const newRef = useRef();
    const confirmRef = useRef();

    let _navClick = () => {
        stepChange('confirmationEmail');
    };
    // 格式验证
    let _formatCheck = useCallback(() => {
        let res = true;
        if (password.trim() !== password) {
            newRef.current.setErrorMessage(FJLocalStore._('password-without-blank-space'));
            res = false;
            return res;
        } else {
            newRef.current.setInit();
        }
        if (password.length === 0) {
            res = false;
            newRef.current.setErrorMessage(FJLocalStore._('enter-password-here'));
            return res;
        } else {
            newRef.current.setInit();
        }
        if (password.length < 9) {
            res = false;
            newRef.current.setErrorMessage(FJLocalStore._('password-least-nine-character'));
            return res;
        } else {
            newRef.current.setInit();
        }
        if (confirm.trim() !== confirm) {
            confirmRef.current.setErrorMessage(FJLocalStore._('password-without-blank-space'));
            res = false;
            return res;
        } else {
            newRef.current.setInit();
        }
        if (confirm.length === 0) {
            res = false;
            confirmRef.current.setErrorMessage(FJLocalStore._('enter-password-here'));
            return res;
        } else {
            confirmRef.current.setInit();
        }
        if (confirm.length < 9) {
            res = false;
            confirmRef.current.setErrorMessage(FJLocalStore._('password-least-nine-character'));
            return res;
        } else {
            confirmRef.current.setInit();
        }
        if (confirm !== password) {
            res = false;
            confirmRef.current.setErrorMessage(FJLocalStore._('please-enter-same-password'));
            return res;
        } else {
            confirmRef.current.setInit();
        }
        return res;
    }, [password, confirm]);

    let _resetClick = useCallback(() => {
        let res = _formatCheck();
        if (!res) {
            return;
        }
        setLoad(true);
        resetClick(password, confirm, option => {
            setLoad(false);
            if (option.networkFail) {
                setErrTip(option.errTip);
            } else if (option.result === true) {
                setErrTip(null);
            } else {
                setErrTip(option.errTip);
            }
        });
    }, [_formatCheck, resetClick, password, confirm]);

    let _passwordChange = value => {
        newRef.current.setInit();
        setErrTip(null);
        setPassword(value);
    };
    let _confirmChange = value => {
        confirmRef.current.setInit();
        setErrTip(null);
        setConfirm(value);
    };

    let _enterReset = useCallback(
        event => {
            if (event.keyCode === 13) {
                _resetClick();
            }
        },
        [_resetClick],
    );

    useEffect(() => {
        FJUtil.addEvent(window, 'keydown', _enterReset);
        return () => {
            FJUtil.removeEvent(window, 'keydown', _enterReset);
        };
    }, [_enterReset]);
    return (
        <div
            className={classNames(Style.reset_box, {
                [Style.reset_box_show]: active,
                [Style.reset_box_popup]: popupType,
            })}
        >
            <FJNav title={FJLocalStore._('reset-password')} onClick={_navClick} popupType={popupType} />
            {/* 特殊处理 */}
            <div style={{ userSelect: 'none' }}>
                <input
                    defaultValue={email}
                    autoComplete='UserName'
                    className={Style.input_one}
                    type='text'
                    style={{ width: '10px', opacity: 0 }}
                />
                <input className={Style.input_one} type='text' style={{ width: '10px', opacity: 0 }} />
            </div>
            <FJInput
                value={password}
                onChange={_passwordChange}
                label={FJLocalStore._('new-password')}
                placeholder={FJLocalStore._('enter-password-here')}
                type='password'
                hasRightIcon
                // className={Style.input_one}
                inputClassName={Style.input}
                iconClassName={Style.inputRightIcon}
                ref={newRef}
                preventAutoComplete
            />
            <div style={{ userSelect: 'none' }}>
                <input className={Style.input_two} type='text' style={{ width: '10px', opacity: 0 }} />
            </div>
            <FJInput
                value={confirm}
                onChange={_confirmChange}
                label={FJLocalStore._('confirm-new-password')}
                placeholder={FJLocalStore._('enter-password-here')}
                type='password'
                hasRightIcon
                // className={Style.input_two}
                inputClassName={Style.input}
                ref={confirmRef}
                popupType={popupType}
                preventAutoComplete
            />
            <FJErrTip errTip={errTip} />
            <FJButton
                text={FJLocalStore._('save-new-password')}
                small={popupType}
                className={Style.submit_btn}
                isLoading={load}
                onClick={_resetClick}
            />
        </div>
    );
};
export default ResetPasswordBrick;
